import { Avatar } from '@base-ui/react/avatar';
import { avatarPastelColor } from '@/lib/utils/avatarColor';

type UserAvatarProps = {
  firstname?: string | null;
  surname?: string | null;
  name?: string | null;
  email?: string | null;
  src?: string | null;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  showTooltip?: boolean;
};

export default function UserAvatar({
  firstname,
  surname,
  name,
  email,
  src,
  size = 'md',
  showTooltip = true
}: UserAvatarProps) {
  const nameInitials = name
    ? name
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0])
        .join('')
        .toUpperCase()
    : '';
  const initials =
    `${firstname?.[0] || ''}${surname?.[0] || ''}`.toUpperCase() || nameInitials || email?.[0]?.toUpperCase() || '?';

  const displayName = [firstname, surname].filter(Boolean).join(' ') || name?.trim() || email || undefined;
  const sizeClasses =
    size === 'xs'
      ? 'w-[22px] h-[22px] text-[11px]'
      : size === 'sm'
        ? 'w-[28px] h-[28px] text-xs'
        : size === 'lg'
          ? 'w-16 h-16 text-xl'
          : 'w-9 h-9 text-sm';
  const bgColor = avatarPastelColor(initials);

  return (
    <Avatar.Root
      title={showTooltip ? displayName : undefined}
      aria-label={displayName}
      className={`${sizeClasses} flex-shrink-0 rounded-full flex items-center justify-center font-medium text-content-default`}
      style={{ backgroundColor: bgColor }}
    >
      {src ? <Avatar.Image src={src} alt={displayName} className="h-full w-full rounded-full object-cover" /> : null}
      <Avatar.Fallback className="flex items-center justify-center">{initials}</Avatar.Fallback>
    </Avatar.Root>
  );
}
